module.exports = __webpack_public_path__ + "static/media/android.07b1a4bd.svg";